import { useMemo } from 'react';
import { config } from '../../../config';
import { useTenantDashboardUrl } from '../../../lib/tenantDashboard';
import { dashboardOrigin } from './dispatchLink';

/**
 * Where to link a dispatch booking, for this console instance.
 *
 * The one place that touches `document` for this question; everything it
 * decides is pure and tested in `dispatchLink.ts`. Memoised on the one input
 * that can move — the tenant's dashboard, which lands with `/meta` — since the
 * referrer is fixed for the document's life and the config is a build constant.
 *
 * `embedded` is passed rather than sniffed from `window.self !== window.top`:
 * the question is not "am I in a frame" but "is my parent the dispatch
 * dashboard", and only the source knows that. A console framed by anything
 * else must not send an agent to whoever framed it.
 */
export function useDashboardOrigin(embedded: boolean): string | null {
  const tenantDashboard = useTenantDashboardUrl();
  return useMemo(
    () => dashboardOrigin(embedded, globalThis.document?.referrer, config.dashboardBase, tenantDashboard),
    [embedded, tenantDashboard],
  );
}
